module.exports = __webpack_public_path__ + "static/media/trust-companies1.cc6c1c67.webp";